// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5x-0";
export var startPickingButton = "_5x-1";